<script>
import Item from '../Item.vue'

export default {
  props: {
    pointers: Array,
    steps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    subdomain() {
      return this.cname.value.split('.').slice(0, -2).join('.')
    },
    domain() {
      return this.cname.value.split('.').slice(-2).join('.')
    },
    cname() {
      return this.pointers.find(({ type }) => type === 'CNAME')
    },
    a() {
      return this.pointers.find(({ type }) => type === 'A')
    },
    items() {
      const aStatus = this.steps.A
      const cnameStatus = this.steps.CNAME

      let base = [
        {
          completed: aStatus || cnameStatus,
          content: 'Gå til <a href="https://domene.shop/login">Domeneshop</a> og logg inn',
        },
        {
          completed: aStatus || cnameStatus,
          content: `Naviger til "Mine domener" og klikk på <b>${this.domain}</b>`,
        },
        {
          completed: aStatus || cnameStatus,
          content: 'Naviger deretter til “DNS-pekere”',
        },
        {
          completed: cnameStatus,
          content: 'Legg til en CNAME post',
          items: [
            'Trykk på vis “Avanserte innstillinger”',
            'Gå til nederste rad for å legge til en ny peker',
            'I feltet for "Vertsnavn", skriv inn www',
            'I feltet “Type” velger du “CNAME”',
            {
              content: 'I feltet for "Data", skriv inn',
              target: this.cname.target,
            },
            'Lagre endringene ved å klikke det grønne plus ikonet til høyre.',
            'Dersom du har en annen CNAME peker som benytter "Vertsnavn" www, må denne slettes slik at domenet fungerer riktig',
          ],
        },
      ]

      if (this.a) {
        return [
          ...base,
          {
            completed: aStatus,
            content: 'Legg til en A-post',
            items: [
              'Naviger til nederste rad for å legge til en ny peker',
              'I feltet for "Vertsnavn", la det stå tomt',
              'I feltet “Type” velger du “A”',
              {
                content: 'I feltet for "Data", skriv inn',
                target: this.a.target,
              },

              'Lagre endringene ved å klikke det grønne plus ikonet til høyre',
              'Dersom du har en annen A peker med "Oppføring" som er tom, må denne slettes slik at domenet fungerer riktig.',
            ],
          },
        ]
      }
      return base
    },
  },
  components: {
    Item,
  },
}
</script>

<template>
  <div class="dns-provider-domeneshop">
    <Item v-for="(item, index) in items" :value="item" :order="index"> </Item>
  </div>
</template>

<style lang="scss">
.dns-provider-domeneshop {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
